export default __webpack_public_path__ + "static/media/twitter-icon-black.1e5394f1.svg";